import { z } from "zod/v4"
import { Scope } from "../lib/payment"

export enum PlatformStore {
  IAP = 0,
  IAB = 1,
  // WEB = "web",
}

export namespace PlatformStore {
  export function parse(src: string): PlatformStore {
    switch (src) {
      case "iap":
        return PlatformStore.IAP
      case "iab":
        return PlatformStore.IAB
      default:
        throw new Error(`Invalid store name: ${src}`)
    }
  }

  export function safeParse(src: string): { success: true; data: PlatformStore } | { success: false; error: string } {
    switch (src) {
      case "iap":
        return { success: true, data: PlatformStore.IAP }
      case "iab":
        return { success: true, data: PlatformStore.IAB }
      default:
        return { success: false, error: `Invalid store name: ${src}` }
    }
  }

  export function toScope(src: PlatformStore) {
    switch (src) {
      case PlatformStore.IAP:
        return Scope.IAP
      case PlatformStore.IAB:
        return Scope.IAB
      default:
        throw new Error("Something went wrong.")
    }
  }
}

export const PlatformStoreSchema =
  z.union([
    z.literal(PlatformStore.IAP),
    z.literal(PlatformStore.IAB)
  ])
    .describe(`課金プラットフォームを示します

 - 0: App Store
 - 1: Google Play
`)
